export default __webpack_public_path__ + "bd15d5eebaeaafe36d22e090cd6add4a.png";